export default {
  key: "zh_TW",
  主頁: "主頁",
  日期: "日期",
  時間: "時間",
  地點: "地點",
  對象: "對象",
  語言: "語言",
  報名: "報名",
  查詢: "查詢",
  主辦: "主辦單位",
  更多: "更多",
  活動資訊: "活動資訊",
  媒體發佈: "媒體發佈",
  聯繫我們: "聯絡我們",
  共讀活動: "共讀活動",
  共讀點: "共讀點",
  全城共讀: "全城共讀",
  协办单位: "協辦單位",
  返回: "返回",
  預熱活動: "預熱活動",
  澳門圖書館周: "澳門圖書館周",
  "澳門全城共讀月-啟動儀式": "澳門全城共讀月-啟動儀式",
  其他活動: "其他活動",
  聯絡我們: "聯絡我們",
  專題講座: "專題講座",
  讀書會: "讀書會",
  室內活動: "室內活動",
  戶外廣場活動: "戶外廣場活動",
  戶外廣場舞台節目: "戶外廣場舞台節目",
  更多活動詳情即將公佈: "更多活動詳情即將公佈，敬請期待。",
  過往精彩照片 : "過往精彩照片",
};
